import axiosInstance from "../../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL } from "../../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../../Base/helper/baseFunctions";


export const GetVMBulkUploadStageHelper = async () => {
    return await axiosInstance(`/visitors/getVisitorStage`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
        }
    })
        .then((res) => {
            return { message: "Update Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to update", hasError: false, data: err?.response?.data }
        })
}

export const UpdateVMBulkUploadStageHelper = async (params) => {
    return await axiosInstance(`/visitors/updateVisitorStage`, {
        method: "PUT",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            pre_registration_visitors_detail_stage_details: params?.pre_registration_visitors_detail_stage_details,
            pre_registration_visitors_detail_stage_pk: params?.pre_registration_visitors_detail_stage_pk
        }
    })
        .then((res) => {
            return { message: "Update Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable to update", hasError: false, data: err?.response?.data }
        })
}


export const DeleteVMBulkUploadStageHelper = async (params) => {
    return await axiosInstance(`/visitors/deleteVisitorStage`, {
        method: "DELETE",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            pre_registration_visitors_detail_stage_pk: params?.pre_registration_visitors_detail_stage_pk,
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Failed to delete", hasError: false, data: err?.response?.data }
        })
}



export const AddVisitorStagetoMainHelper = async (params) => {
    return await axiosInstance(`/visitors/addVisitorStagetoMain`, {
        method: "POST",
        baseURL: HRMS_EMPLOYEE_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: getUserId(),
            visited_employee_email: params?.visited_employee_email
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Unable", hasError: false, data: err?.response?.data }
        })
}